import { evidenceSteps } from "@/mocks/homeMocks";

const chainCover =
  "https://readdy.ai/api/search-image?query=An%20editorial%20investigation%20mood%20board%20on%20a%20desk%20showing%20spread%20printed%20documents%2C%20a%20printed%20timeline%20strip%2C%20highlighted%20red%20marker%20lines%2C%20paper%20clips%20and%20red%20seal%20stamps%2C%20top%20down%20flat%20lay%2C%20aged%20paper%20background%2C%20soft%20warm%20window%20light%20from%20left%2C%20documentary%20evidence%20dossier%20aesthetic%2C%20charcoal%20ink%20and%20rust%20red%20accents%2C%20high%20detail%20editorial%20photography&width=900&height=1100&seq=bage-chain-cover&orientation=portrait";

export default function EvidenceChain() {
  return (
    <section id="chain" className="w-full">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        {/* 标题 */}
        <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
          <span className="inline-block h-px w-8 bg-primary-400"></span>
          证据链完整梳理
        </p>
        <div className="mt-3 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading max-w-3xl text-2xl md:text-4xl font-black leading-tight tracking-tight text-foreground-950">
            一场「倒贴炒作」，从爆料到定性的五环证据链
          </h2>
          <span className="w-fit shrink-0 cursor-pointer whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700">
            <i className="ri-file-list-3-line mr-1.5" aria-hidden="true"></i>全档 · 跨栏案例
          </span>
        </div>
        <p className="mt-4 max-w-3xl text-sm md:text-base leading-7 text-foreground-600">
          以当下热度最高的一桩爆料为样本，把从零散的匿名帖到可下结论的实锤，中间的每一步都摊开给你看——证据怎么到手、怎么互证、又在哪一环留了白。
        </p>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[0.9fr_1.3fr] md:gap-8">
          {/* 封面 */}
          <div className="relative aspect-[4/3] w-full overflow-hidden rounded-xl lg:aspect-auto lg:min-h-[460px]">
            <img
              src={chainCover}
              alt="证据链完整梳理 实锤 档案桌面"
              title="扒哥黑料 证据链 档案整理"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                闭环 · 已定性
              </span>
              <p className="mt-3 max-w-sm text-sm leading-6 text-background-100">
                此案无「反转」剧本，五环全部落位，截图与时间轴按档编号可查。
              </p>
            </div>
          </div>

          {/* 五环证据链 */}
          <ol className="relative flex flex-col gap-0 border-l border-background-300 pl-0">
            {evidenceSteps.map((s, i) => (
              <li key={s.key} className="group relative pl-8 md:pl-10 pb-7 last:pb-0">
                {/* 节点 */}
                <span
                  className={`absolute left-[-13px] top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 ${
                    i === evidenceSteps.length - 1
                      ? "border-accent-400 bg-accent-500 text-background-50"
                      : "border-primary-200 bg-background-50 text-primary-600"
                  }`}
                >
                  <i
                    className={i === evidenceSteps.length - 1 ? "ri-check-line text-xs" : "ri-flag-line text-[10px]"}
                    aria-hidden="true"
                  ></i>
                </span>
                <div className="flex items-center gap-3">
                  <span className="font-heading text-sm font-black text-primary-600">{s.step}</span>
                  <span className="rounded-md bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                    {s.key}
                  </span>
                </div>
                <h3 className="font-heading mt-2 text-lg font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">{s.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}